// extracted by mini-css-extract-plugin
export var infoRow = "_pf-2";
export var labelContainer = "_pf-0";
export var rightInfo = "_pf-1";